import { InjectionToken } from '@angular/core';
import { ILoggerConfiguration } from '../../models/i-cloud-logger-configuration.model';

export const LOG_CONFIG = new InjectionToken<ILoggerConfiguration>('logger.config');
export const LOG_APP_NAME = new InjectionToken<string>('logger.appName');
